<template>
  <div class="HomePanel">

    <HeaderSection
      title="Welkom bij de Renovatieversneller Monitor">
      <p>
        Hier moet een introductie tekst komen... 
      </p>

      <Link 
        class="Link__more" 
        arrow 
        label="Meer over Renovatieversneller Monitor" 
        :to="{ name: 'page-about' }" />
    </HeaderSection>

    <ContentSection 
      grow
      class="ContentSection--home">
      <Menu 
        :horizontal="false"
        arrow
        :items="primaire_links"
      />
      <SectionHeader label="Uitgelicht" />

      <HighlightedVerhaal slug="utrecht-inside-out" />

    </ContentSection>

    <ContentSection>
      <ContentTip>
        <p>
          Heb je ook een tip voor deze monitor?
        </p>
        <Link 
          arrow 
          label="Laat het ons weten!" 
          :to="{ name: 'page-contact' }" />
      </ContentTip>
    </ContentSection>

  </div>
</template>

<script>

import Link from '@/components/Link';
import Menu from '@/components/Menu';
import SectionHeader from '@/components/section/Header'; 
import HeaderSection from '@/components/section/HeaderSection';
import ContentSection from '@/components/section/ContentSection';
import ContentTip from '@/components/content/Tip';
import HighlightedVerhaal from '@/components/highlighted/Verhaal';

export default { 
  name: 'home',
  components: {
    Link,
    Menu,
    SectionHeader,
    HeaderSection,
    ContentSection,
    ContentTip,
    HighlightedVerhaal
  },
  data() {
    return {
      primaire_links: [
        {
          label: 'Alle Projecten',
          to: { name: 'list-projecten' }
        },
        {
          label: 'Projecten per partij',
          to: { name: 'list-partijen' }
        },
      ]
    }
  }
}
</script>

<style lang="scss">
  .HomePanel {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 24px;

    .ContentSection--home {
      padding: 32px 32px 32px;

      p {
        margin: 0;
        font-family: $font_body;
        font-size: 16px;
      }
      .Menu {
        margin-top: 8px;
        font-weight: bold;
        font-size: 16px;
        line-height: 32px;
        letter-spacing: -0.01px;
        margin-bottom: 48px;
      }
    }
  }

</style>
